<template>
  <div class="page login">
    <Header @clickHome="clickHome" />

    <div class="loginFormBox container">
      <LoginForm @onClickSignInEmit="loginAction" />

      <MiddleUI @changeCheck="changeCheck" :userData="userData" />

      <LoginButtons 
        @kakaoSignUp="kakaoSignUp" 
        @kakaoSignIn="kakaoSignIn" />

      <CommonDialog ref="refCommonDialog" @clickOk="clickPopupOk" />
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import Header from "./comp/Header.vue";
import MiddleUI from "./comp/MiddleUI.vue";
import LoginButtons from "./comp/LoginButtons.vue";
import LoginForm from "./comp/LoginForm.vue";
import Cookies from "js-cookie";
const modelService = require("@/utils/dataModel.js");
import CommonDialog from "@/_bayer/commonComp/dialog/CommonDialog.vue";

export default {
  components: {
    Header,
    MiddleUI,
    LoginButtons,
    LoginForm,
    CommonDialog,
  },
  data() {
    return {
      pwShow: false,
      userData: modelService.userModel(),
      isChecked: false,
    };
  },
  methods: {
    kakaoSignUp(e) {
      console.log("kakaoSignUp", e);
      this.$router.push({ path: "/signUp" }); //.catch(() => {});
    },
    kakaoSignIn(e) {
      console.log("login page kakaoSignIn", e);
      this.loginAction(e);
    },
    changeCheck(e) {
      this.isChecked = e;
    },
    clickHome() {
      this.$router.push({ path: "/home" }).catch(() => {});
    },
    loginAction(e) {
      console.log("e", e);
      e.userAgent = navigator.userAgent.toLowerCase();
      this.signIn(e).then((res) => {
        if (res === undefined) return;

        // 아이디 비번을 틀린 경우
        let msg = "등록되지 않은 아이디 이거나, 아이디 또는 비밀번호를 잘못 입력하셨습니다.<br/> 아이디 또는 비밀번호를 다시 입력하시거나 카카오로 로그인해주세요."
        if (res === 401) {
          this.$refs.refCommonDialog.open(msg);
          return;
        }

        // 로그인 성공후 로그인 아이디 기억하기
        if (this.isChecked) {
          Cookies.set("bayerFarmIsSaveLoginId", e.loginId, {expires: 100000});
        } else {
          Cookies.set("bayerFarmIsSaveLoginId", "");
        }

        // 리로드
        window.location.href = "/";
      });
    },
    clickPopupOk() {},
    ...mapActions(["signIn", "saveDataPreLoginQuery"]),
  },
  computed: {
    ...mapState(["loginCheck"]),
  },
};
</script>

<style lang="scss">
.login {
  .v-btn.btn-kakao {
    background: #f6d523;
    color: #000000;
  }

  .link-group {
    padding: 0 0 0 10px;
    text-align: right;
    margin: 10px auto 0 !important;
    width: 90vw;
    max-width: 100%;
    justify-content: space-between;
    align-items: flex-start;
    .v-input--checkbox {
      margin-top: 0;
      padding-top: 0;
    }
    .v-label {
      font-size: 12px;
    }
    .v-btn {
      // text-decoration: underline;
      font-weight: 400;
      color: $text-red;
      font-size: 12px;
    }
  }
}
</style>